var _rect, _rect2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    fill: "#ED3241"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_241_387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7949 5.41747C13.0713 5.69933 13.0673 6.15224 12.7858 6.42907L6.83102 12.2864L3.21377 8.72838C2.93234 8.45155 2.92826 7.99864 3.20467 7.71678C3.48108 7.43491 3.93331 7.43083 4.21474 7.70766L6.83102 10.2811L11.7849 5.40835C12.0663 5.13152 12.5185 5.1356 12.7949 5.41747Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_241_387)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00024,
    y: 3.5,
    width: 9.99961,
    height: 9.99961,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.988abb1ba3bac37fa52f4aae97e7245a.svg";
export { ForwardRef as ReactComponent };